module.exports = __webpack_public_path__ + "img/case-logo-51.ab3ad64c.png";